import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Tabs } from 'antd';
import { Layout } from 'features/layout';
import TopGlobalVendors from 'features/performance/components/TopGlobalVendors';
import GlobalVendorsTable from 'features/performance/components/GlobalVendorsTable';
import { GlobalNamesContainer, AddVendorsFormContainer } from 'features/vendors';
import { toggleVendorsForm } from 'state/slice/tabSlice';
import { ToastContainer } from 'react-toastify';
import DownArrow from 'img/ArrowLineDown.png';
import { RootState } from 'state/store';

const VendorOverview: React.FC = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('top10');
  const vendor = useSelector((state: any) => state.activeTab?.addVendors);
  const userRole = useSelector((state: RootState) => (state.user as any).userData?.role);
  const isRootUser = userRole === 'root_user';

  const handleVendorsForm = (bool: boolean) => {
    dispatch(toggleVendorsForm(bool));
  };

  const items = [
    {
      key: 'top10',
      label: 'Top Global Vendors (beta)',
      children: <TopGlobalVendors />,
    },
    ...(isRootUser ? [{
      key: 'globalNames',
      label: 'Global Names',
      children: <GlobalNamesContainer />,
    }] : []),
    {
      key: 'globalVendors',
      label: 'Global Vendors',
      children: <GlobalVendorsTable />,
    },
  ];

  return (
    <Layout>
      <div style={{ display: 'flex', flexDirection: 'column', gap: '28px' }}>
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          <h1>Vendor Overview</h1>
          {isRootUser && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  cursor: 'pointer',
                }}
                onClick={() => handleVendorsForm(true)}
              >
                <span>Add Vendors</span>
                <img src={DownArrow} alt='down arrow' style={{ width: '16px' }} />
              </div>
            </div>
          )}
        </div>

        <Tabs
          activeKey={activeTab}
          onChange={(key) => setActiveTab(key)}
          items={items}
        />

        {vendor && <AddVendorsFormContainer />}
        <ToastContainer />
      </div>
    </Layout>
  );
};

export default VendorOverview;
